// extracted by mini-css-extract-plugin
export var actionIcon = "_my-0";